import { render, staticRenderFns } from "./BaseSwitchInput.vue?vue&type=template&id=424f0465"
import script from "./BaseSwitchInput.vue?vue&type=script&lang=js"
export * from "./BaseSwitchInput.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitchInput.vue?vue&type=style&index=0&id=424f0465&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports